export default __webpack_public_path__ + "static/B35-34d4aee0551700962c6ad5002efc3772.png";